// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/sar-responsible-agencies.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/sar-responsible-agencies/sar-responsible-agencies.js';

mount([g0]);
